
import { Component, Vue } from "vue-property-decorator";
import { Field, Toast } from "vant";
import { getIngredientList } from "@/api/ccxIntegratedService";
import { Getter } from "vuex-class";

@Component({
  components: {
    [Field.name]: Field,
  },
})
export default class AddGoodsAssociate extends Vue {
  @Getter companyId!: string;

  private ingredientName = ""; // 商品名称
  private ingredientId = ""; // 食材id
  private suggestions: any[] = []; // 食材库列表数据
  private showSuggestions = false;
  private searchTimer: any = null;
  private barcode = "";

  get fromPage (): string {
    return (this.$route.query.from as string) || "";
  }

  private buildAddGoodsQuery (extra: Record<string, string>): Record<string, string> {
    const query = { ...extra };
    if (this.fromPage) {
      query.from = this.fromPage;
    }
    return query;
  }

  toScan () {
    this.$bridge.callHandler('toQRCodePage', {}, (res: string) => {
      // 调用原生扫码接口成功后，更新商品条码
      this.barcode = res
      this.$router.push({
        path: "/addGoods",
        query: this.buildAddGoodsQuery({
          barcode: this.barcode,
          fromType: '1',
        }),
      });
    })
  }

  // 确认商品
  handleConfirm () {
    // this.searchSuggestions();
    if (!this.ingredientName.trim()) {
      Toast("请录入商品名称");
      return;
    }
    this.$router.push({
      path: "/addGoods",
      query: this.buildAddGoodsQuery({
        ingredientName: this.ingredientName,
        fromType: '2',
      }),
    });
  }

  // // 重置
  // handleReset () {
  //   this.ingredientName = "";
  //   this.ingredientId = "";
  //   this.suggestions = [];
  //   this.showSuggestions = false;
  //   this.searchTimer = null;
  //   this.barcode = "";
  // }

  // // 下一步
  // handleNext () {
  //   if (!this.ingredientName.trim()) {
  //     Toast("请录入商品名称");
  //     return;
  //   }
  //   let query: any = {
  //     ingredientName: this.ingredientName,
  //   };

  //   if (this.ingredientId) {
  //     query.ingredientId = this.ingredientId;
  //   }

  //   this.$router.push({
  //     path: "/addGoods",
  //     query,
  //   });
  // }

  /**
   * 处理输入事件
   */
  handleInput() {
    if (!this.ingredientName) {
      this.showSuggestions = false;
      this.suggestions = []
    }
    // if (this.searchTimer) {
    //   clearTimeout(this.searchTimer);
    // }

    // this.searchTimer = setTimeout(() => {
    //   this.searchSuggestions();
    // }, 300);
  }

  /**
   * 处理输入框聚焦
   */
  handleFocus() {
    if (this.ingredientName && this.suggestions.length > 0) {
      this.showSuggestions = true;
    }
  }

  /**
   * 搜索建议
   */
  // async searchSuggestions() {
  //   this.ingredientId = "";
  //   if (!this.ingredientName.trim()) {
  //     this.suggestions = [];
  //     this.showSuggestions = false;
  //     return;
  //   }

  //   try {
  //     // 调用真实的API接口获取建议数据
  //     const { data } = await getIngredientList({
  //       goodsName: this.ingredientName,
  //       storeId: this.companyId,
  //     });
  //     this.suggestions = data;
  //     this.suggestions.push({
  //       ingredientId: 'mismatch',
  //       ingredientName: '匹配不准确'
  //     })
  //     this.showSuggestions = this.suggestions.length > 0;
  //   } catch (error) {
  //     this.suggestions = [];
  //     this.showSuggestions = false;
  //   }
  // }
  /**
   * 高亮匹配部分
   */
  // highlightMatch(text) {
  //   if (!this.ingredientName) return text;
  //   const reg = new RegExp(`(${this.ingredientName})`, "gi"); // 匹配关键字（忽略大小写）
  //   return text.replace(reg, `<span style="color: #1989fa">$1</span>`);
  // }
  // highlightParts(text: string) {
  //   if (!this.ingredientName) return [{ text, match: false }];

  //   const keyword = this.ingredientName;
  //   const reg = new RegExp(`(${keyword})`, "gi");
  //   const parts: any[] = [];

  //   let lastIndex = 0;
  //   let match;

  //   while ((match = reg.exec(text)) !== null) {
  //     // 前面非匹配部分
  //     if (match.index > lastIndex) {
  //       parts.push({ text: text.slice(lastIndex, match.index), match: false });
  //     }
  //     // 匹配部分
  //     parts.push({ text: match[0], match: true });
  //     lastIndex = match.index + match[0].length;
  //   }

  //   // 剩余部分
  //   if (lastIndex < text.length) {
  //     parts.push({ text: text.slice(lastIndex), match: false });
  //   }

  //   return parts;
  // }

  /**
   * 选择建议项
   */
  // selectSuggestion(item: any) {
  //   this.ingredientName = item.ingredientName;
  //   this.ingredientId = item.ingredientId;
  //   this.showSuggestions = false;
  //   this.$nextTick(() => {
  //     this.showSuggestions = false;
  //   });
  // }

  /**
   * 清空输入
   */
  clearInput() {
    this.ingredientName = "";
    this.suggestions = [];
    this.showSuggestions = false;
    this.$nextTick(() => {
      // (this.$refs.goodsNameInput as any)?.focus();
    });
  }

  /**
   * 完成按钮
   */
  // async handleDone() {
  //   if (!this.ingredientName.trim()) {
  //     Toast("请录入商品名称");
  //     return;
  //   }
  //   let query: any = {
  //     ingredientName: this.ingredientName,
  //   };

  //   // if (this.ingredientId) {
  //   //   query.ingredientId = this.ingredientId;
  //   // }

  //   this.$router.push({
  //     path: "/addGoods",
  //     query,
  //   });
  // }
}
